//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: ${({ alignSelf = "unset" }) => alignSelf};
    gap: 25px;
    width: 500px;
    margin: 20px 40px;
`;
export const Content = styled.section`
    display: flex;
    align-items: center;
    gap: 15px;
`;
export const MorePages = styled.div`
    font-size: 20px;
    letter-spacing: 2px;
    color: var(--light-gray-5);
    cursor: default;
`;